// extracted by mini-css-extract-plugin
export default {"cls1":"eAyOpNmxiV0X_uBNfsbA","cls2":"H9jx24WUhVtzSx8hEuwa eAyOpNmxiV0X_uBNfsbA","isPhone":"QUAUuKVwORWmx9RvCQe7","bookingAppRedesign":"hHhtGl3QfFGMh0dzBevU"};